import { PropTypes, css, styled } from '../lib/imports';

const baseStyles = () => css`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

const Footer = styled('div')(baseStyles);

Footer.propTypes = {
  children: PropTypes.node,
};

export default Footer;
